var _defineProperty = require('babel-runtime/helpers/define-property').default;

(function () {
  Flint.file('mframework/views/wistiaVideo.js', function (require) {
    var _reactMotion = require('react-motion');

    Flint.staticStyles('WistiaVideo', {
      '$wistia_embed': '#_flintapp wistia_embed.WistiaVideo, #_flintapp .WistiaVideo.wistia_embed, #_flintapp .ViewWistiaVideo.wistia_embed, #_flintapp .WistiaVideo > .wistia_embed',
      '$wrapper': '#_flintapp wrapper.WistiaVideo, #_flintapp .WistiaVideo.wrapper, #_flintapp .ViewWistiaVideo.wrapper, #_flintapp .WistiaVideo > .wrapper'
    }, {
      '$wistia_embed': {},
      '$wrapper': {
        overflow: 'hidden',

        alignItems: 'center',
        zIndex: 1,
        position: 'relative'
      }
    });
    Flint.view('WistiaVideo', function (view, on, $) {
      var context = initContext(view, {
        colors: atom()
      });

      var pro = initPro(view, {
        videoKey: M.requiredAtom(),

        // Wrapping Wistia config
        allowPause: M.defaultAtom(true),
        allowPlay: M.defaultAtom(true),
        autoPlay: M.defaultAtom(false),
        controlsVisibleOnLoad: M.defaultAtom(true),
        endVideoBehavior: M.defaultAtom('default'), // default | reset | loop
        initialTime: M.defaultAtom(null),
        initialVolume: M.defaultAtom(null), // null means previous Wistia setting
        playerColor: M.defaultAtom(context.colors.get().accent),
        showPlaybar: M.defaultAtom(true),
        showVolume: M.defaultAtom(true),
        wmode: M.defaultAtom('transparent'),

        // Non-Wistia config
        enabled: M.defaultAtom(true),
        smoothVolume: M.defaultAtom(false),

        // Style
        circle: M.defaultAtom(false),
        height: M.defaultAtom(400 * 9 / 16),
        width: M.defaultAtom(400),
        videoStyle: M.mapAtom({}),

        // Parent-controlled state
        playing: atom(),
        time: atom(),
        volume: atom()
      });

      var wistiaId = pro.videoKey.derive(function (videoKey) {
        if (videoKey.indexOf('videos/wistia/') != 0) {
          throw new Error('Invalid Wistia video key: ' + videoKey);
        }
        return videoKey.split('/')[2];
      });

      var wantToPlay = atom(pro.autoPlay.get());
      var targetVolume = atom(pro.initialVolume.get());
      var time = atom(pro.initialTime.get());
      var wistiaTime = atom();

      // Controlled by <Motion> as a function of targetVolume
      var volume = atom(targetVolume.get());

      var VIEW_ID = parseInt(Math.random() * 10000000000);
      var wistia = atom();
      var lastRenderedWistiaConfig = atom();
      var refreshCount = atom(0);

      // Data reported from Wistia
      var aspect = atom();
      var duration = atom();
      var videoData = derivation(function () {
        var data = IMap({
          aspect: aspect.get(),
          duration: duration.get()
        });
        if (List(data.values()).findIndex(function (v) {
          return v === undefined;
        }) == -1) {
          return data;
        }
      });
      videoData.reactor(function (videoData) {
        if (view.props.onVideoData) {
          view.props.onVideoData({ videoData: videoData });
        }
      }).start();

      pro.playing.react(function (propPlaying) {
        if (propPlaying != null) {
          wantToPlay.set(propPlaying);
        }
      });
      pro.time.react(function (propTime) {
        if (propTime != null) {
          time.set(propTime);
        }
      });
      pro.volume.react(function (propVolume) {
        if (propVolume !== undefined) {
          targetVolume.set(propVolume);
        }
      });

      var playing = derivation(function () {
        return pro.enabled.get() && wantToPlay.get();
      });
      playing.react(function (playing) {
        if (wistia.get()) {
          if (playing) {
            wistia.get().play();
          } else {
            wistia.get().pause();
          }
        }
      });

      wistiaTime.reactor(function (wistiaTime) {
        time.set(wistiaTime);

        if (view.props.onTime) {
          view.props.onTime({ time: wistiaTime });
        }
      }).start();

      time.react(function (time) {
        if (wistia.get()) {
          if (wistiaTime.get() === undefined || Math.abs(time - wistiaTime.get()) > 0.25) {
            wistia.get().time(time);
          }
        }
      });

      volume.react(function (volume) {
        if (wistia.get()) {
          wistia.get().volume(volume);
        }
      });

      var diameter = derivation(function () {
        return Math.min(pro.width.get(), pro.height.get());
      });
      var width = derivation(function () {
        if (pro.circle.get()) {
          var aspectGuess = aspect.get() || 16 / 9;
          return Math.max(diameter.get(), diameter.get() * aspectGuess);
        } else {
          return pro.width.get();
        }
      });
      var height = derivation(function () {
        if (pro.circle.get()) {
          var aspectGuess = aspect.get() || 16 / 9;
          return Math.max(diameter.get(), diameter.get() / aspectGuess);
        } else {
          return pro.height.get();
        }
      });

      wistia.reactor(function (wistia) {
        wistia.hasData(function () {
          transact(function () {
            aspect.set(wistia.aspect());
            duration.set(wistia.duration());
          });
        });

        wistia.bind('play', function () {
          if (!playing.get()) {
            if (wistiaTime.get() == null && time.get() != null) {
              // This happens when programmatically seeking to a time when Wistia's
              // state is beforePlay. It changes to play, but then it'll change
              // immediately back to pause. So do nothing.
            } else {
                // Since our state would have had the video stay paused, this must
                // be a user-triggered event.
                if (pro.allowPlay.get()) {
                  wantToPlay.set(true);
                } else {
                  wistia.pause();
                }
              }
          }
        });

        wistia.bind('pause', function () {
          if (playing.get()) {
            // Since our state would have had the video keep playing, this must
            // be a user-triggered event.
            if (duration.get() && time.get() >= duration.get() - 0.5) {
              // Ignore this because it's probably justfrom the video ending
              return;
            }

            if (pro.allowPause.get() && !pro.playing.get()) {
              wantToPlay.set(false);
            } else {
              wistia.play();
            }
          }
        });

        wistia.bind('volumechange', function (v) {
          if (v != volume.get()) {
            // User-triggered volume change
            targetVolume.set(v);
            volume.set(v);
          }
        });

        wistia.bind('timechange', function (t) {
          wistiaTime.set(t);
        });

        wistia.bind('end', function () {
          if (view.props.onEnd) {
            view.props.onEnd();
          }
        });
      }).start();

      var tellWistia = function tellWistia(wistiaMessage) {
        // Wistia's script watches a global message queue so we can "tell it"
        // to call our callback with a handle or update some configs.

        // We use refreshCount.get() + 1 because we need to get the message
        // to Wistia before this component's rendered elements refresh
        var matcher = 'video_' + VIEW_ID + '_' + (refreshCount.get() + 1);
        window._wq = window._wq || [];
        _wq.push(_defineProperty({}, matcher, wistiaMessage));
      };

      var refreshWistia = function refreshWistia() {
        if (wistia.get()) {
          wistia.get().remove();
          wistiaTime.set(undefined);
        }

        var wistiaConfigSnapshot = wistiaConfig.get();
        tellWistia(function (wistiaVideoHandle) {
          return wistia.set(wistiaVideoHandle);
        });
        tellWistia(wistiaConfigSnapshot.toJS());
        refreshCount.set(refreshCount.get() + 1);

        on.delay(1, function () {
          lastRenderedWistiaConfig.set(wistiaConfigSnapshot);
        });
      };

      pro.videoKey.react(function (videoKey) {
        if (view.mounted) {
          lastRenderedWistiaConfig.set(null);
        }
      });

      var wistiaConfig = derivation(function () {
        return IMap({
          autoPlay: playing.get(),
          controlsVisibleOnLoad: pro.controlsVisibleOnLoad.get(),
          endVideoBehavior: pro.endVideoBehavior.get(),
          playbar: pro.showPlaybar.get(),
          playerColor: pro.playerColor.get(),
          time: time.get(),
          volumeControl: pro.showVolume.get(),
          volume: targetVolume.get(),
          wmode: pro.wmode.get()
        });
      });

      var needsRefreshing = derivation(function () {
        var lastConfig = lastRenderedWistiaConfig.get();
        if (!lastConfig) {
          return true;
        }
        return !immutable.is(IMap({
          endVideoBehavior: pro.endVideoBehavior.get(),
          playbar: pro.showPlaybar.get(),
          playerColor: pro.playerColor.get(),
          volumeControl: pro.showVolume.get(),
          wmode: pro.wmode.get()
        }), IMap({
          endVideoBehavior: lastConfig.get('endVideoBehavior'),
          playbar: lastConfig.get('playbar'),
          playerColor: lastConfig.get('playerColor'),
          volumeControl: lastConfig.get('volumeControl'),
          wmode: lastConfig.get('wmode')
        }));
      });
      needsRefreshing.react(function (needsRefreshing) {
        if (needsRefreshing && view.mounted) {
          refreshWistia();
        }
      });

      on.mount(function () {
        if (lastRenderedWistiaConfig.get() === undefined) {
          // First render
          refreshWistia();
        } else {
          lastRenderedWistiaConfig.set(null);
        }
      });

      on.unmount(function () {
        if (wistia.get()) {
          wistia.get().remove();
        }
      });view.render(function () {
        return view.el(
          ['Motion', 1],
          {
            defaultStyle: { v: targetVolume.get() || 0 },
            style: {
              v: pro.smoothVolume.get() && targetVolume.get() != null && targetVolume.get() != volume.get() ? (0, _reactMotion.spring)(targetVolume.get()) : targetVolume.get()
            }
          },
          function (style) {
            if (style.v != null) {
              setTimeout(function () {
                volume.set(style.v);
              }, 1);
            }

            return view.el(
              ['wrapper', 1],
              { style: pro.videoStyle.get().toJS() },
              Flint.iff(refreshCount.get()) && view.el(['div', 1], { if: refreshCount.get(),
                key: 'render_' + refreshCount.get(),
                id: 'video_' + VIEW_ID + '_' + refreshCount.get(),
                className: 'wistia_embed wistia_async_' + wistiaId.get()
              })
            );
          }
        );
      });

      $["wistia_embed"] = function (_, _index) {
        return {
          width: width.get(),
          height: height.get()
        };
      };

      $["wrapper"] = function (_, _index) {
        return { width: pro.circle.get() ? diameter.get() : pro.width.get(),
          height: pro.circle.get() ? diameter.get() : pro.height.get(), borderRadius: pro.circle.get() ? '50%' : 8
        };
      };
    });
  })
})();
//# sourceMappingURL=wistiaVideo.js.map
